import { render, staticRenderFns } from "./el-dropdown-item.vue?vue&type=template&id=982137ee"
import script from "./el-dropdown-item.vue?vue&type=script&lang=js"
export * from "./el-dropdown-item.vue?vue&type=script&lang=js"
import style0 from "./el-dropdown-item.vue?vue&type=style&index=0&id=982137ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports